import { useTranslation } from "react-i18next";
import {
  Bar,
  BarChart,
  CartesianGrid,
  ResponsiveContainer,
  XAxis,
  YAxis,
} from "recharts";

import { IFitbitSleepStageSummary } from "../../../../../../@types/Fitbit";
import { StagesChartWrapper } from "./FitbitSleepStagesChart.styles";

const BAR_COLOR = "#54A6AA";

type FitbitSleepStagesBarChartProps = {
  stageSummary: IFitbitSleepStageSummary | null;
  width?: number | string;
  height?: number | string;
};

function minutesToHours(value: number | null | undefined): number {
  return value != null && value > 0 ? value / 60 : 0;
}

export function FitbitSleepStagesBarChart({
  stageSummary,
  width = "100%",
  height = 240,
}: FitbitSleepStagesBarChartProps) {
  const { t } = useTranslation();

  const data = [
    {
      name: t("patientPage_measurementModal_sleep_awake"),
      hours: minutesToHours(stageSummary?.awakeMinutes),
    },
    {
      name: t("patientPage_measurementModal_sleep_rem"),
      hours: minutesToHours(stageSummary?.remMinutes),
    },
    {
      name: t("patientPage_measurementModal_sleep_light"),
      hours: minutesToHours(stageSummary?.lightMinutes),
    },
    {
      name: t("patientPage_measurementModal_sleep_deep"),
      hours: minutesToHours(stageSummary?.deepMinutes),
    },
  ];

  const peak = Math.max(...data.map((d) => d.hours));
  const yMax = Math.max(1, Math.ceil(peak));

  return (
    <StagesChartWrapper>
      <ResponsiveContainer width={width} height={height}>
        <BarChart
          data={data}
          margin={{ top: 12, right: 16, left: 0, bottom: 8 }}
        >
          <CartesianGrid
            strokeDasharray="4 4"
            vertical={false}
            stroke="#D8D8D8"
          />

          <XAxis
            dataKey="name"
            tickLine={false}
            axisLine={false}
            tick={{ fill: "#727272", fontSize: 12 }}
            interval={0}
            tickMargin={8}
          />

          <YAxis
            orientation="right"
            domain={[0, yMax]}
            allowDecimals={false}
            tickLine={false}
            axisLine={false}
            tick={{ fill: "#727272", fontSize: 12 }}
            tickFormatter={(value) => `${value}h`}
            width={48}
          />

          <Bar
            dataKey="hours"
            fill={BAR_COLOR}
            isAnimationActive={false}
            barSize={48}
          />
        </BarChart>
      </ResponsiveContainer>
    </StagesChartWrapper>
  );
}
